export const PARTICIPANTS_MODULE_ERROR_MESSAGES = {
  PHOTO_UPLOAD_MISSING_ETAG: "Missing ETag in upload response",
} as const;
